import axios from "axios";
import fs from "fs";
import formData from "form-data";
import Cookies from 'js-cookie';
// import { message } from 'antd'

export default function ajax(
    url,
    data = {},
    type = "GET",
    responseType = null,
    token = null,
    cookie = false
) {
    console.log(data);
    // console.log("url:",url, "data:", data, "type",type, "res",responseType, "token",token);
    return new Promise((resolve, reject) => {
        let ps;
        // 构造 headers 对象
        const headers = token ? { Authorization: `${token}` } : {};
        if (cookie) {
            let userId = Cookies.get('randomUserId');
            
            // 如果没有找到用户ID，生成一个新的随机ID并存入cookie
            if (!userId) {
                userId = 'user_' + Math.random().toString(36).substr(2, 9);
                Cookies.set('randomUserId', userId, { expires: 7 });
            }
            headers['X-User-ID'] = userId;  // 将用户ID添加到请求头
        }
        // console.log(headers);
        switch (type) {
            case "GET":
                // GET 请求
                ps = axios.get(url, { params: data, headers });
                break;
            case "POST":
                // POST 请求
                // console.log(url, data);
                const postConfig = { headers };
                if (responseType) {
                    postConfig.responseType = responseType;
                }
                ps = axios.post(url, data, postConfig);
                break;
            case "DELETE":
                // DELETE 请求
                ps = axios.delete(url, { data, headers });
                break;
            case "PUT":
                // PUT 请求
                ps = axios.put(url, data, { headers });
                break;
            case "PATCH":
                ps = axios.patch(url, data, { headers });
                break;
            default:
                reject(new Error("Invalid request type"));
                return;
        }

        ps.then((response) => {
            resolve(response.data);
        }).catch((error) => {
            resolve({ status: -1, message: error.message });
            console.log("请求出错" + error.message);
        });
    });
}


// function ajaxFile(
//     url,
//     data,
//     responseType = null
// ){
//     return new Promise((resolve, reject) => {
//         let ps;
//         const form = new formData();
//         form.append('file', fs.createReadStream(data));
//         if (responseType) {
//             ps = axios.post(url, form, { responseType: responseType });
//         } else {
//             ps = axios.post(url, form);
//         }
//         ps.then((response) => {
//             resolve(response.data);
//         }).catch((error) => {
//             resolve({ status: -1, message: error.message });
//             console.log("请求出错" + error.message); // message.error('请求出错' + error.message, 1.0); // message.error('暂无数据！');
//         });
//     });
// }

// import axios from 'axios'
// axios.defaults.timeout = 10000
// axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded'
// export default {
//   fetchGet (url, params = {}) {
//     return new Promise((resolve, reject) => {
//       axios.get(url, params).then(res => {
//         resolve(res.data)
//       }).catch(error => {
//         reject(error)
//       })
//     })
//   },
//   fetchPost (url, params = {}) {
//     return new Promise((resolve, reject) => {
//       axios.post(url, params).then(res => {
//         resolve(res.data)
//       }).catch(error => {
//         reject(error)
//       })
//     })
//   }
// }
